import React, { type PropsWithChildren } from 'react';

import type { UseQueryResult } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { TrainingCandidateDetailResponse } from '@/services/api';

export interface CoachInterviewResultContextValue {
  resultQuery: UseQueryResult<
    TrainingCandidateDetailResponse,
    AxiosError<unknown, ExplicitAny>
  >;
}

const CoachInterviewResultContext = React.createContext<
  CoachInterviewResultContextValue | undefined
>(undefined);

export const useCoachInterviewResultContext = () => {
  const ctx = React.useContext(CoachInterviewResultContext);
  if (!ctx) {
    throw new Error('Missing parent <CoachInterviewResultProvider> component');
  }
  return ctx;
};

export const CoachInterviewResultProvider: React.FC<
  PropsWithChildren<{ value: CoachInterviewResultContextValue }>
> = ({ value, children }) => {
  return (
    <CoachInterviewResultContext.Provider value={value}>
      {children}
    </CoachInterviewResultContext.Provider>
  );
};
